import { pinCommand, queueKey, usePins, WorkQueues } from "@nexxt/app-kit";
import { Button, formatTime } from "@nexxt/ui";
import { Pin, PinOff } from "lucide-react";
import { m } from "../../../paraglide/messages.js";
import { useMe } from "../auth/me";
import { useQueues } from "./queues";

// "Now" (flussi-per-ruolo §1): the queues of the user's roles, "your turn" first, then what waits on others. No
// charts; every queue opens its filtered list, and can be pinned to the sidebar with its count (ADR-114).

export function HomePage() {
  const me = useMe();
  const pins = usePins();
  const { yourTurn, waiting, loading, error, failed, updatedAt } = useQueues();

  return (
    <section aria-labelledby="now-title" className="mx-auto flex w-full max-w-3xl flex-col gap-6 p-4 sm:gap-8 sm:p-8">
      <header className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h1 id="now-title" className="text-xl font-semibold">
          {m.home_greeting({ name: me.firstName ?? me.email })}
        </h1>
        {updatedAt > 0 && (
          <span className="text-xs text-muted-foreground">{m.updated_at({ time: formatTime(updatedAt) })}</span>
        )}
      </header>
      <WorkQueues
        yourTurn={yourTurn}
        waiting={waiting}
        loading={loading}
        error={error}
        failed={failed}
        trailing={(q) => <PinButton pinKey={queueKey(q.id)} name={q.title} pinned={pins.includes(queueKey(q.id))} />}
      />
    </section>
  );
}

function PinButton({ pinKey, name, pinned }: { pinKey: string; name: string; pinned: boolean }) {
  const pin = pinCommand(pinKey, name, pinned);
  return (
    <Button
      variant="ghost"
      size="icon"
      className="mx-1 shrink-0 sm:mx-2"
      aria-label={pin.label}
      aria-pressed={pinned}
      onClick={pin.run}
    >
      {pinned ? <PinOff aria-hidden /> : <Pin aria-hidden className="text-muted-foreground" />}
    </Button>
  );
}
